/**
 * Saves of a session's time used that are still on their way, by planned task. Typing a time into a session's timer
 * saves it as the field loses focus, which clicking its ✓ does too, so the save and "mark used" went out together. The
 * server, finding no time used yet, marked the planned time used, and the typed time landed after it (Petr,
 * 2026-10-09: typed 1h 10m, the session showed the planned 1h 04m). Marking used waits for these first.
 */
const pending = new Map<number, number>();

export const startUsedSave = (plannedTaskId: number) => pending.set(plannedTaskId, (pending.get(plannedTaskId) || 0) + 1);

export const endUsedSave = (plannedTaskId: number) => {
  const left = (pending.get(plannedTaskId) || 1) - 1;
  if (left > 0) pending.set(plannedTaskId, left);
  else pending.delete(plannedTaskId);
};

export const hasUsedSave = (plannedTaskId: number) => pending.has(plannedTaskId);
